import {
  getPosts,
  getPublicPosts,
  getPostByAlias,
  getPublicPostByAlias,
} from '@/firebase/repositories/posts';

import * as types from './actionTypes';
import { SET_POSTS, SET_POST } from './mutationTypes';

export default {
  [types.loadData]({ getters, commit }) {
    const loadPostsMethod = getters.isMember ? getPosts : getPublicPosts;

    return loadPostsMethod()
      .then((posts) => {
        commit(SET_POSTS, posts);
      });
  },
  [types.loadPost]({ commit }, { alias, publicKey }) {
    const promise = publicKey ? getPublicPostByAlias(alias, publicKey) : getPostByAlias(alias);

    return promise
      .then((post) => {
        commit(SET_POST, post);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js